import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuAlign", "menuRole", "renderMenuOnMount", "disabled", "href", "id"];
import React from 'react';
import Dropdown from './Dropdown';
import DropdownToggle from './DropdownToggle';
import DropdownMenu, { alignPropType } from './DropdownMenu';
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of
 * [`Dropdown`'s props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu-related props are passed to the `Dropdown.Menu`
 */

var DropdownButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    children = _ref.children,
    bsPrefix = _ref.bsPrefix,
    rootCloseEvent = _ref.rootCloseEvent,
    variant = _ref.variant,
    size = _ref.size,
    menuAlign = _ref.menuAlign,
    menuRole = _ref.menuRole,
    renderMenuOnMount = _ref.renderMenuOnMount,
    disabled = _ref.disabled,
    href = _ref.href,
    id = _ref.id,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(DropdownToggle, {
    id: id,
    href: href,
    size: size,
    variant: variant,
    disabled: disabled,
    childBsPrefix: bsPrefix
  }, title), /*#__PURE__*/React.createElement(DropdownMenu, {
    align: menuAlign,
    role: menuRole,
    renderOnMount: renderMenuOnMount,
    rootCloseEvent: rootCloseEvent
  }, children));
});
DropdownButton.displayName = 'DropdownButton';
export default DropdownButton;